import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import {UtilsService} from '../common/services/utils.service';
import { Router,ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;
declare var sell_car_reg_year: Function;

@Component({
  selector: 'app-sell-car',
  templateUrl: './sell-car.component.html',
  styleUrls: ['./sell-car.component.css','../../assets/css/jquery-ui.css']
})
export class SellCarComponent implements OnInit {

  constructor(
    private httpserviceService:HttpserviceService,
    private sessionsService:SessionsService,
    private utilsService:UtilsService,
    private router:Router,
    private route:ActivatedRoute 
    ) { }

  uploadCarFormGroup;
  carRegNo;
  carBrand;
  carModel;
  carMileage;
  carRegYear;
  carVariant;
  carRegState;
  saleType;
  carMarketValue;
  selfInspection;
  carImage1Input;
  carImage2Input;
  carImage3Input;
  carImage4Input;
  carImage5Input;
  carImage6Input;
  carImage7Input;
  carImage1File="";
  carImage2File="";
  carImage3File="";
  carImage4File="";
  carImage5File="";
  carImage6File="";
  carImage7File="";
  requestInProcess=false;
  isLoading=true;
  isSubmit=false;
  stateList=[];
  brandList=[];
  brandModelList=[];
  modelList=[{"id":0,"name":"Select brand first"}];
  modelVariantList=[];
  variantList=[{"id":0,"name":"Select model first"}];
  fuelTypeList=[];
  carRegNotValid=false;
  sessionProfileType:number=-1;
  actionStatus:boolean=false;
  carType:number=1;
  type:string='1';


  @ViewChild('carRegDate') carRegDate: ElementRef;;

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0);
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(!this.actionStatus || (this.sessionProfileType!=0 && this.sessionProfileType!=2))
    {
      show_okshan_alert("You don't have access of sell car");
      this.router.navigate(['home']);      
    }

    this.type=this.route.snapshot.queryParamMap.get('type');
    this.uploadCarFormGroup=new FormGroup(
      {
        carRegNo: new FormControl("",[Validators.required]),
        carBrand: new FormControl("0",[Validators.required,Validators.min(1)]),
        carModel: new FormControl("0",[Validators.required,Validators.min(1)]),
        carMileage: new FormControl("",[Validators.required]),
        carRegYear: new FormControl("0",[Validators.required,Validators.min(1)]),
        carVariant: new FormControl("0",[Validators.required,Validators.min(1)]),
        carRegState: new FormControl("0",[Validators.required,Validators.min(1)]),
        saleType: new FormControl(this.type,[Validators.required]),
        carMarketValue: new FormControl("",[Validators.required]),   
        selfInspection : new FormControl(false),
        carImage1Input: new FormControl(""),
        carImage2Input: new FormControl(""),
        carImage3Input: new FormControl(""),
        carImage4Input: new FormControl(""),
        carImage5Input: new FormControl(""), 
        carImage6Input: new FormControl(""),
        carImage7Input: new FormControl(""),
      }
    );

    this.stateList=this.sessionsService.getSession("state_list"); 
    this.brandList=this.sessionsService.getSession("brand_list");   
    this.getBrandModelList();
    this.getModelVariantList();    
    setTimeout(() => {
     sell_car_reg_year(); 
    }, 10000);
       
  }

  carImage1(event) {  
    var filesize = ((event.target.files[0].size/1024)/1024).toFixed(4);
    if(parseFloat(filesize) <= 5){
		if (event.target.files.length > 0) {
		  const file = event.target.files[0];
		  //this.registerationFormGroup.patchValue({
			this.carImage1File= file;
		  //});
		}
		else{
		   this.carImage1File="";
		}
	}else{
		alert("Selected Image size is greater than 5MB. Please reselect image.");
		this.carImage1File="";
	}
  }

  carImage2(event) { 
    var filesize = ((event.target.files[0].size/1024)/1024).toFixed(4);
    if(parseFloat(filesize) <= 5){ 
		if (event.target.files.length > 0) {
		  const file = event.target.files[0];
		  //this.registerationFormGroup.patchValue({
			this.carImage2File= file;
		  //});
		}
		else{
		   this.carImage2File="";
		}
	}else{
		alert("Selected Image size is greater than 5MB. Please reselect image.");
		this.carImage2File="";
	}
  }

  carImage3(event) {  
    var filesize = ((event.target.files[0].size/1024)/1024).toFixed(4);
    if(parseFloat(filesize) <= 5){ 
		if (event.target.files.length > 0) {
		  const file = event.target.files[0];
		  //this.registerationFormGroup.patchValue({
			this.carImage3File= file;
		  //});
		}
		else{
		   this.carImage3File="";
		}
	}else{
		alert("Selected Image size is greater than 5MB. Please reselect image.");
		this.carImage3File="";
	}
  }

  carImage4(event) {  
    var filesize = ((event.target.files[0].size/1024)/1024).toFixed(4);
    if(parseFloat(filesize) <= 5){ 
		if (event.target.files.length > 0) {
		  const file = event.target.files[0];
		  //this.registerationFormGroup.patchValue({
			this.carImage4File= file;
		  //});
		}
		else{
		   this.carImage4File="";
		}
	}else{
		alert("Selected Image size is greater than 5MB. Please reselect image.");
		this.carImage4File="";
	}
  }

  carImage5(event) {  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.carImage5File= file;
      //});
    }
    else{
       this.carImage5File="";
    }
  }

  carImage6(event) {  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.carImage6File= file;
      //});
    }
    else{
       this.carImage6File="";
    }
  }

   carImage7(event) {  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.carImage7File= file;
      //});
    }
    else{
       this.carImage7File="";
    }
  }

  /** proceedCarUpload function used to proceed car upload */ 
  proceedCarUpload(data)
  {
    this.isSubmit=true;  
    if(this.carRegDate.nativeElement.value=="")
    {
      this.carRegNotValid=true;
      return false;
    }
    else
    {      
      data.carRegYear=this.carRegDate.nativeElement.value;
      this.carRegNotValid=false;
    }  
    if(this.uploadCarFormGroup.valid)
    {      
    let blankiImgsCount=0;
    if(this.carImage1File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage2File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage3File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage4File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage5File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage6File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     if(this.carImage7File=="")
     {
       blankiImgsCount=blankiImgsCount+1
     }
     const formData = new FormData();
     formData.append('profile_id',this.sessionsService.getSession("id"));
     formData.append('registeration_no',data.carRegNo.split(" ").join(""));
     formData.append('model',data.carModel);
     formData.append('variant',data.carVariant);
     formData.append('car_brand',data.carBrand);
     formData.append('mileage',data.carMileage);
     formData.append('regitration_date',data.carRegYear);
     formData.append('state',data.carRegState);
     formData.append('pic1',this.carImage1File);
     formData.append('pic2',this.carImage2File);
     formData.append('pic3',this.carImage3File);
     formData.append('pic4',this.carImage4File);
     formData.append('pic5',this.carImage5File);
     formData.append('pic6',this.carImage6File);
     formData.append('pic7',this.carImage7File);
     formData.append('fare_market_value','0');
     formData.append('expected_price',data.carMarketValue);
     formData.append('sale_by',data.saleType);
     this.carType=data.saleType;
     if(data.selfInspection==true || data.selfInspection=="true")
     {
     formData.append('re_profile_id',this.sessionsService.getSession("id"));
     }
     else
     {
     formData.append('re_profile_id',"0");  
     }
     if(blankiImgsCount>5)
     {
       show_okshan_alert("Select minimum 2 pictures");
     }    
     else
     {
     this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.carUploadRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.carUploadResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })
     }
    }
  }

  /** carUploadResponse function used to handle response */
  carUploadResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {
     this.isSubmit=false; 
     this.requestInProcess=false;
     this.isLoading=true;
     this.uploadCarFormGroup.reset();   

     this.carImage1File="";
     this.carImage2File="";
     this.carImage3File="";
     this.carImage4File="";  

     this.uploadCarFormGroup.controls["carBrand"].setValue("0");
     this.uploadCarFormGroup.controls["carModel"].setValue("0");
     this.uploadCarFormGroup.controls["carVariant"].setValue("0");
     this.uploadCarFormGroup.controls["carRegState"].setValue("0");
     this.uploadCarFormGroup.controls["saleType"].setValue("1");

    show_okshan_alert("Car details are uploaded successfully");
     setTimeout(() => {
       this.router.navigate(['my-cars']);
      // if(this.carType==1)
      // { 
      // this.router.navigate(['fixed-price-cars']);
      // }
      // else if(this.carType==2)
      // { 
      // this.router.navigate(['auction-cars']); 
      // }
     }, 3000);
     }
     else
     {
     show_okshan_alert(response.reason);
     this.requestInProcess=false;
     this.isLoading=true;
     } 
  }

  /** getBrandModelList function used to get brand model list */ 
  getBrandModelList()
  { 
    let result =this.httpserviceService.getBrandModelListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getBrandModelListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandModelListResponse function used to handle response */
  getBrandModelListResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.brandModelList=response.list;     
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** onChangeBrand function used to perform event on brand change */
  onChangeBrand(value)
  {
   this.modelList=this.brandModelList[value];
  }

  /** getModelVariantList function used to get model variant list */ 
  getModelVariantList()
  { 
    let result =this.httpserviceService.getModelVariantListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getModelVariantListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getModelVariantListResponse function used to handle response */
  getModelVariantListResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.modelVariantList=response.list;     
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  } 

  /** onChangeModel function used to perform event on model change */
  onChangeModel(value)
  {
   this.variantList=this.modelVariantList[value];
  }

  /** validateCarNumber function used to validate car registration number */
  validateCarNumber(value)
  {
  let val=value.split(" ").join(""); 
  val=val.replace(/[^\w\s]/gi, "");  
  this.uploadCarFormGroup.controls["carRegNo"].setValue(val.toLocaleUpperCase());  
  }

}
